const freezeVoices = (voices) => Object.freeze(voices.map((voice) => Object.freeze(voice)))

export const SPELL_AUDIO_SPECS = Object.freeze({
  fire: Object.freeze({
    profile: 'rising-ignition',
    duration: 0.82,
    voices: freezeVoices([
      { type: 'sawtooth', frequency: 196, endFrequency: 284, offset: 0, attack: 0.018, release: 0.62, gain: 0.09 },
      { type: 'sawtooth', frequency: 392, endFrequency: 568, offset: 0.07, attack: 0.018, release: 0.58, gain: 0.075 },
      { type: 'triangle', frequency: 784, endFrequency: 1137, offset: 0.14, attack: 0.012, release: 0.48, gain: 0.055 },
    ]),
    noise: Object.freeze({ duration: 0.55, gain: 0.055, filter: 'highpass', frequency: 1800, offset: 0 }),
    pulses: Object.freeze([]),
  }),
  earth: Object.freeze({
    profile: 'low-impact',
    duration: 0.58,
    voices: freezeVoices([
      { type: 'sine', frequency: 92, endFrequency: 64, offset: 0, attack: 0.008, release: 0.46, gain: 0.18 },
      { type: 'triangle', frequency: 62, endFrequency: 48, offset: 0.035, attack: 0.006, release: 0.4, gain: 0.13 },
    ]),
    noise: Object.freeze({ duration: 0.32, gain: 0.14, filter: 'lowpass', frequency: 420, offset: 0 }),
    pulses: Object.freeze([]),
  }),
  water: Object.freeze({
    profile: 'soft-fall-drops',
    duration: 1.08,
    voices: freezeVoices([
      { type: 'sine', frequency: 523, endFrequency: 377, offset: 0, attack: 0.04, release: 0.78, gain: 0.08 },
      { type: 'sine', frequency: 392, endFrequency: 282, offset: 0.14, attack: 0.04, release: 0.78, gain: 0.072 },
      { type: 'triangle', frequency: 261, endFrequency: 188, offset: 0.28, attack: 0.035, release: 0.72, gain: 0.06 },
    ]),
    noise: Object.freeze({ duration: 0.7, gain: 0.035, filter: 'bandpass', frequency: 900, offset: 0.08 }),
    pulses: Object.freeze([]),
  }),
  wind: Object.freeze({
    profile: 'bright-chime',
    duration: 1.28,
    voices: freezeVoices([
      { type: 'triangle', frequency: 659, endFrequency: 791, offset: 0, attack: 0.018, release: 1.15, gain: 0.07 },
      { type: 'sine', frequency: 988, endFrequency: 1186, offset: 0.075, attack: 0.016, release: 1.05, gain: 0.06 },
      { type: 'triangle', frequency: 1318, endFrequency: 1582, offset: 0.15, attack: 0.012, release: 0.92, gain: 0.045 },
    ]),
    noise: Object.freeze({ duration: 0.9, gain: 0.045, filter: 'highpass', frequency: 1100, offset: 0 }),
    pulses: Object.freeze([]),
  }),
  love: Object.freeze({
    profile: 'double-heartbeat-glass',
    duration: 1.18,
    voices: freezeVoices([
      { type: 'sine', frequency: 392, endFrequency: 392, offset: 0.34, attack: 0.03, release: 0.74, gain: 0.055 },
      { type: 'triangle', frequency: 523, endFrequency: 659, offset: 0.42, attack: 0.025, release: 0.7, gain: 0.05 },
      { type: 'sine', frequency: 784, endFrequency: 988, offset: 0.5, attack: 0.02, release: 0.62, gain: 0.04 },
    ]),
    noise: Object.freeze({ duration: 0.72, gain: 0.022, filter: 'lowpass', frequency: 1500, offset: 0.36 }),
    pulses: Object.freeze([
      Object.freeze({ offset: 0, frequency: 76, endFrequency: 48, duration: 0.18, gain: 0.19 }),
      Object.freeze({ offset: 0.22, frequency: 76, endFrequency: 48, duration: 0.18, gain: 0.19 }),
    ]),
  }),
})

export function getSpellAudioSpec(elementKey) {
  return SPELL_AUDIO_SPECS[elementKey] ?? null
}
